import React, { Component } from 'react';
import DrawableCanvas from 'react-drawable-canvas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeMap } from '../../../actions/ts_map_actions.js';
import { updateModal } from '../../../actions/modal.js';
import { updateCanvas } from '../../../actions/ts_canvas_actions.js';
import { setActive } from '../../../actions/ts_active_actions.js';
import { clearDraw } from '../../../actions/ts_overlay_actions.js';
import logger from '../../../actions/log.js';
import Promo from '../../promo/'
import {
  GEARS5,
  ASYLUM,
  BUNKER,
  DAM,
  DISTRICT,
  EXHIBIT,
  FORGE,
  FOUNDATION,
  HARBOR,
  ICEBOUND,
  RECLAIMED,
  TRAININGGROUNDS,
  VASGAR,
} from '../../../utils/maps/types';
class Gears5 extends Component {

  constructor(props) {
      super(props);
  }

changeMap(game,map)
{
  var {overlay} = this.props;
  this.props.changeMap(game,map);
  logger.logMapClick(game,map);
  this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
  this.props.updateModal(false,null);
  this.props.updateCanvas(null,null,[]);
  this.props.setActive(null,null);
}
    render() {
      var {map} = this.props;
        return (
          <div>
                <Promo game={GEARS5} />
                <span className="menuHeaderText">GEARS 5</span><br/><br/>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,ASYLUM);}}>Asylum</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,BUNKER);}}>Bunker</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,DAM);}}>Dam</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,DISTRICT);}}>District</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,EXHIBIT);}}>Exhibit</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,FORGE);}}>Forge</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,FOUNDATION);}}>Foundation</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,HARBOR);}}>Harbor</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,ICEBOUND);}}>Icebound</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,RECLAIMED);}}>Reclaimed</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,TRAININGGROUNDS);}}>Training Grounds</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(GEARS5,VASGAR);}}>Vasgar</button>

          </div>

        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeMap, clearDraw, updateModal, updateCanvas, setActive
    }, dispatch);
}

function mapStateToProps(state) {
    return { map: state.map, overlay: state.overlay, canvas: state.canvas };
}

export default connect(mapStateToProps, mapDispatchToProps)(Gears5);



// WEBPACK FOOTER //
// ./src/app/components/menu/games/gears5.jsx